// extracted by mini-css-extract-plugin
export default {"carousel_container":"carousel_carousel_container__gClqT","carousel_item":"carousel_carousel_item__gLxQi"};